import React from 'react';
import { useIntl } from 'react-intl';
import trim from 'lodash/trim';
import StandardTextField from 'Common/Components/StandardTextField';
import Wrapper from './styled';

const CustomCronExpression = ({
  id, value, setValue, onChangeCustomCronExpression, disabled
}) => {
  const intl = useIntl();
  const isValid = (text) => {
    const re = /^(?:(?:[1-5]?\d(?:-[1-5]?\d)?|\*)(?:\/[1-9]\d?)?)(?:,(?:(?:[1-5]?\d(?:-[1-5]?\d)?|\*)(?:\/[1-9]\d?)?))* (?:(?:2[0-3]|1?\d)(?:-(?:2[0-3]|1?\d))?|\*)(?:\/[1-9]\d?)?(?:,(?:(?:2[0-3]|1?\d)(?:-(?:2[0-3]|1?\d))?|\*)(?:\/[1-9]\d?)?)* (?:(?:3[01]|[12]\d|[1-9])(?:-(?:3[01]|[12]\d|[1-9]))?|\*)(?:\/[1-9]\d?)?(?:,(?:(?:3[01]|[12]\d|[1-9])(?:-(?:3[01]|[12]\d|[1-9]))?|\*)(?:\/[1-9]\d?)?)* (?:(?:1[0-2]|[1-9])(?:-(?:1[0-2]|[1-9]))?|\*)(?:\/[1-9]\d?)?(?:,(?:(?:1[0-2]|[1-9])(?:-(?:1[0-2]|[1-9]))?|\*)(?:\/[1-9]\d?)?)* (?:[0-6](?:-[0-6])?|\*)(?:\/[1-9]\d?)?(?:,(?:[0-6](?:-[0-6])?|\*)(?:\/[1-9]\d?)?)*$/;
    return re.test(text);
  };

  const onChange = (value) => {
    const trimmedValue = trim(value);
    setValue(value);
    if (isValid(trimmedValue)) {
      onChangeCustomCronExpression(trimmedValue);
    } else {
      onChangeCustomCronExpression('');
    }
  };

  return (
    <Wrapper>
      <StandardTextField
        name="customCronExpression"
        value={ value }
        error={ Boolean(value) && !isValid(trim(value)) }
        errorMessage={ intl.formatMessage({ id: 'schedule.createEditSchedule.customCronExpression.error' }) }
        onChange={ onChange }
        disabled={ disabled }
        placeholder="0 0 1 */3 *"
        id={ id }
      />
    </Wrapper>
  );
};

export default CustomCronExpression;
